import React from "react";
import Reflux from "reflux";
import axios from 'axios';
import { removeToken } from "../../utils";
import {
    Card, Container, Row, CardTitle, CardBody, Label,
    FormGroup,
    Input, FormText,
    Form, Col, Button,
    UncontrolledTooltip
} from "reactstrap";
// core components
import Header from "../../components/Headers/Header";
import { withRouter } from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import moment from "moment";
import memoize from 'memoize-one';
import 'moment/locale/es'
import ReactBSAlert from "react-bootstrap-sweetalert";
//import FileDownload from 'js-file-download';
import { UserStore } from "../../store/UserStore";
import DataTable from 'react-data-table-component';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import CircularProgress from '@material-ui/core/CircularProgress';
const FileDownload = require('js-file-download');

const sortIcon = <ArrowDownward />;

const columnsFilesb = memoize(clickHandler => [
    {
        selector: row => row.id, name: 'ID', sortable: true, width: '120px', style: {
            color: 'rgba(0,0,0,.54)'
        },
    },
    {
        selector: row => row.name, name: 'NOMBRE DEL FICHERO', sortable: true, width: '250px', style: {
            color: 'rgba(0,0,0,.54)'
        },
    },
    {       // eslint-disable-next-line react/button-has-type
        cell: (row) => <Button onClick={clickHandler} color="info" size="sm" className="float-right" id={row.name} value={row.name}>Bajar</Button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
    { selector: row => row.modate, name: 'Ultima Modificación', sortable: true, width: '180px', center: false },
    { selector: row => row.size, name: 'Tamaño en Bytes', sortable: true, width: '150px', center: false },

]);

const columnsFiles = memoize(clickHandler => [
    { selector: row => row.dirname, name: 'CARPETA', sortable: true, width: '150px', center: false },
    {
        selector: row => row.filename, name: 'NOMBRE DEL FICHERO', sortable: true, width: '250px', style: {
            color: 'rgba(0,0,0,.54)'
        },
    },
    {       // eslint-disable-next-line react/button-has-type
        cell: (row) => <Button onClick={clickHandler} color="info" size="sm" className="float-right" id={row.filename} value={row.filepath}>Bajar</Button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    },
    {       // eslint-disable-next-line react/button-has-type
        cell: (row) => <Button onClick={clickHandler} color="danger" size="sm" className="float-right" id={row.filename} value={row.filepath}>Borrar</Button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    }
]);

const capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.toLowerCase().charAt(0).toUpperCase() + s.slice(1)
}

const customStyles = {
    headRow: {
        style: {
            border: 'none',

        },
    },
    headCells: {
        style: {
            color: '#202124',
            fontSize: '12px',
            fontWeight: 'bold',
            wordBreak: 'break-word',
            paddingLeft: '8px',
            paddingRight: '8px',
            minWidth: '55px'

        },
    },
    cells: {
        style: {
            paddingLeft: '8px',
            paddingRight: '8px',
            minWidth: '55px',
            wordBreak: 'break-word',
            fontFamily: '"Open Sans", sans-serif;'
        },
    },
    rows: {
        highlightOnHoverStyle: {
            backgroundColor: 'rgb(230, 250, 250)',
            borderBottomColor: '#FFFFFF',
            borderRadius: '25px',
            outline: '1px solid #FFFFFF',
            fontSize: '12px',
        },
    },
    pagination: {
        style: {
            border: 'none',
        },
    },
};


class gestionFicheros extends Reflux.Component<any, any> {
    public formRef: any = null;
    public inputEl: any = null;
    public validFileExtensions = ["jpg", "jpeg", "png"];
    public maxFileSize = 3;
    public fileInput: any = null;
    lastFilters = {};
    state = {
        UserStore: {},
        isLoading: false,
        currentPage: 0,
        pageSize: 0,
        pageCount: 0,
        count: 0,
        contrato: "",
        empresaDetailTotal: [],
        empresaSeleccionado: false,
        passwordModificado: false,
        municipioBuscar: "",
        idUser: '',
        directorio: [{
            type: "folder",
            name: "/",
            files: [{}]
        }],
        companyIdUser: '',
        companyNameGlobal: '',
        userGroupId: 1000,
        userId: '',
        esAgencia: false,
        esComercializadora: false,
        esAdFincas: false,
        saveDataEmpresa: false,
        updateDataEmpresa: false,
        updateEmpresaButtonDisabled: true,
        saveEmpreButtonDisabled: true,
        saveXMLButtonDisabled: true,
        buscarButtonDisabled: true,
        show: false,
        saveButtonDisabled: true,
        showFilters: true,
        toggledClearRows: false,
        locale: 'es',
        inputIdDisabled: true,
        inputDisabled: true,
        nombreMunicipio: "",
        municipios: [{ id: "", valor: 0 }],
        alert: null,
        imgCollection: [],
        arrayfiles: 0

    };

    constructor(props) {
        super(props);
        this.store = UserStore;
        this.formRef = React.createRef();
        this.onFileChange = this.onFileChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.confirmAlertExit = this.confirmAlertExit.bind(this);
        this.logout = this.logout.bind(this);
        this.inputEl = React.createRef();
    }


    componentWillReceiveProps() {

        const usuario: any = JSON.parse(JSON.stringify(this.state.UserStore['data']))
        const companyNameGlobal = usuario.company;
        const companyIdUser = usuario.companyId;
        const userGroupId = usuario.user_group_id
        const userId = usuario.id
        const esComercializadora = usuario.comercializadora
        const esAgencia = usuario.agencia
        const esAdFincas = usuario.adFincas

        if (userGroupId === 1000) {
            this.setState({
                activeUser: true
            })
        };
        this.setState({
            companyNameGlobal,
            companyIdUser,
            userGroupId,
            userId,
            esComercializadora,
            esAgencia,
            esAdFincas

        });
    };

    componentDidMount() {

        this.getFiles();

    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    logout = async () => {

        removeToken();
        localStorage.removeItem("lastFilters");
        localStorage.removeItem("user");
        localStorage.removeItem("lastFiltersEmpre");
        localStorage.removeItem("lastFiltersMulti");
        localStorage.removeItem('lastFiltersMultiGas');
        localStorage.removeItem('lastFiltersGas');
        //this.props.client.cache.reset();
        //this.props.client.resetStore();
        this.props.history.push(`/auth/login`);
    };

    //////////////////////////////////////////////////////////////////////////////////////7

    hideAlert = () => {
        this.setState({
            alert: null
        });
    };

    warningAlert = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Error en la base de datos"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Existe un error en la Base de datos.
                </ReactBSAlert>
            )
        });
    };

    warningAlertNIF = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="No existen registros que cumplan los requisitos"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Revise los requisitos introducidos
                </ReactBSAlert>
            )
        });
    };

    confirmAlertExit = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Vuelva a iniciar sesión"
                    onConfirm={() => this.logout()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Salir"
                    btnSize=""
                    focusConfirmBtn
                >
                    Se ha cerrado la sesión por seguridad. Por favor, vuelva a iniciar sesión
                </ReactBSAlert>
            )
        });
    };

    warningAlertFiltros = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Existen campos obligatorios sin información"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="warning"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Revise los datos introducidos
                </ReactBSAlert>
            )
        });
    };

    successAlert = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    success
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Correcto"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="success"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    Empresa actualizada correctamente
                </ReactBSAlert>
            )
        });
    };

    successAlertFile = () => {
        this.setState({
            alert: (
                <ReactBSAlert
                    success
                    style={{ display: "block", marginTop: "-100px" }}
                    title="Correcto"
                    onConfirm={() => this.hideAlert()}
                    onCancel={() => this.hideAlert()}
                    confirmBtnBsStyle="success"
                    confirmBtnText="Ok"
                    btnSize=""
                >
                    FIchero bajado correctamente
                </ReactBSAlert>
            )
        });
    };


    //////////////////////////////////////////////////////////////////////////////////////

    onChangeField = (event) => {

        event.persist()

        console.log('event value ', event.target.value)
        console.log('event name ', event.target.name)

        let value = event.target.value;
        let name = event.target.name
        var municipio = ""

        if (event.target.type === "select-one" && value === "0") {
            //delete setFilters[name];
        }

        if (value === "" || value === null) {
            //delete setFilters[name];
        }

        if (name == 'municipio') {

            let indexMunicipio = this.state.municipios.findIndex(object =>
                object.id === value
            ); // 👉️ 1

            if (indexMunicipio !== -1) {
                municipio = this.state.municipios[indexMunicipio].valor
            };

        }



        this.setState({
            municipioBuscar: value,
            nombreMunicipio: municipio
        });
    };


    ////////////////////////////////////////////////////////////////////////////////////////

    showFiltersToggle = () => {
        const showFilters = !this.state.showFilters;

        this.setState({ showFilters });
    };

    //////////////////////////////////////////////////////////////////////////////////////

    getFilterIcon = () => {
        return this.state.showFilters ? "ni-bold-up" : "ni-bold-down";
    };

    ////////////////////////////////////////////////////////////////////////////////////

    clearForm = () => {
        this.setState({
            inputIdDisabled: false,
            inputDisabled: false,
            buscarButtonDisabled: true,
            empresaSeleccionado: false,
            empresaDetailTotal: [],
            passwordModificado: false,
            toggledClearRows: !this.state.toggledClearRows,
            updateEmpresaButtonDisabled: true,
            saveEmpreButtonDisabled: true,
            saveDataEmpresa: false
        });

        this.formRef.current.reset();

    };

    handleClearRows = () => {
        this.setState({ toggledClearRows: !this.state.toggledClearRows })
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    onSubmit(e) {
        e.preventDefault()

        var formData = new FormData();
        for (const key of Object.keys(this.state.imgCollection)) {
            formData.append('files', this.state.imgCollection[key])
        }


        this.setState({

            isLoading: true,
        })


        const userID: any = localStorage.getItem("uuidUser") ? localStorage.getItem("uuidUser") : ""
        const token = localStorage.getItem("token")

        //var user: any = [];

        const datosUsuario = JSON.parse(JSON.stringify(this.state.UserStore['data']))

        const user: any = localStorage.getItem("user");

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
        }

        var municipio = datosUser.ayuntamiento ? datosUser.ayuntamiento : ""
        const codigoINE = datosUser.codigoINE ? datosUser.codigoINE : ""

        const url = "documentosBase"

        formData.append('municipio', municipio);
        formData.append('codigoIne', codigoINE)
        formData.append('usuario', userID);
        formData.append('url', url);



        const headers = {
            
            'Content-Type': 'multipart/form-data',
        };

        let direccionFile = "https://api.nextniro.com/api/v1/files/uploadFiles";

        axios.post(direccionFile, formData, { headers }
        ).then(result => {
            this.setState({
                isLoading: false,
            })

            this.getFiles();
            this.successAlert();
            this.inputEl.current.value = ''
        }).catch((error) => {
            this.setState({
                isLoading: false,
              });
          });

    };



    onFileChange(e) {
        e.persist()

        this.setState(
            ({ imgCollection }) => ({
                imgCollection: e.target.files
            }), () => {
                this.setState(({ imgCollection }) => ({
                    imgCollection: e.target.files
                }))
            })

        //this.setState({ imgCollection: e.target.files })
        //console.log('VALOR DE SELECCION DE FILES -----> ', e.target.files)

        let tamañoFiles = e.target.files.length;
        //console.log('VALOR DE SELECCION DE FILES logitud -----> ', tamañoFiles)

        if (tamañoFiles > 0) {
            this.setState(
                ({ saveButtonDisabled }) => ({
                    saveButtonDisabled: false,
                    arrayfiles: tamañoFiles
                }), () => {
                    this.setState(({ saveButtonDisabled }) => ({
                        saveButtonDisabled: false,
                        arrayfiles: tamañoFiles
                    }))
                })

        } else {
            this.setState(
                ({ saveButtonDisabled }) => ({
                    saveButtonDisabled: true,
                    arrayfiles: tamañoFiles
                }), () => {
                    this.setState(({ saveButtonDisabled }) => ({
                        saveButtonDisabled: true,
                        arrayfiles: tamañoFiles
                    }))
                })
        }

    };


    handleButtonClick = (state) => {
        // eslint-disable-next-line no-console
        state.persist()
        const url = state.target.value;
        const file = state.target.id
        const tipo = state.target.textContent

        console.log('VALOR DE TIPO ------>< ', tipo)

        this.setState({
            isLoading: true,
        });

        const userID: any = localStorage.getItem("uuidUser") ? localStorage.getItem("uuidUser") : ""
        const token = localStorage.getItem("token")

        //var user: any = [];

        const datosUsuario = JSON.parse(JSON.stringify(this.state.UserStore['data']))

        const user: any = localStorage.getItem("user");

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
        }

        const municipio = this.state.nombreMunicipio
        const codigoINE: any = this.state.municipioBuscar

        var urlShort = url.replace('/home/psgestion/docgestiontasas/', '');

        var dataFilters = {
            'municipio': municipio,
            'codigoIne': codigoINE,
            'url': urlShort,
            'file': file
        }

        const valores = JSON.stringify(dataFilters)

        const headers = {
            
            'Content-Type': 'application/json'
        };

        let direccionFile = "https://api.nextniro.com/api/v1/files/downloadFile";

        if (tipo == "Borrar") {
            console.log('dentro de borarar')
            direccionFile = "https://api.nextniro.com/api/v1/files/deleteFile";

        }

        if (tipo == "Bajar") {
            axios.get(direccionFile, { headers, responseType: 'blob', params: { valores } })
                .then((response) => {
                    FileDownload(response.data, file);
                    this.setState({
                        isLoading: false,
                    })

                    //this.successAlertFile();
                }).catch((error) => {
                    this.setState({
                        isLoading: false,
                      });
                  });

        } else if (tipo == "Borrar") {

            axios.get(direccionFile, { headers, params: { valores } })
                .then((response) => {
                    this.getFiles();
                    this.setState({
                        isLoading: false,
                    });
                }).catch((error) => {
                    this.setState({
                        isLoading: false,
                      });
                  });
        };
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    getFiles = async () => {

        console.log('valores de localstorage ------------->   ', localStorage.getItem("uuidUser"), localStorage.getItem("token"))

        const token = localStorage.getItem("token")
        const userData: any = localStorage.getItem("user")

        const datosUsuario = JSON.parse(JSON.stringify(this.state.UserStore['data']))

        const user: any = localStorage.getItem("user");

        var datosUser: any = []
        if (user) {
            datosUser = JSON.parse(user);
            //this.setState({ user: parsed });
        }

        var codigoINE = "";
        var dataFilters = {
            'codigoINE': codigoINE
        }

        const valores = JSON.stringify(dataFilters)

        const headers = {
            
            'Content-Type': 'application/json',
        };
        let direccionFile = "https://api.nextniro.com/api/v1/files/directorio";

        await axios.get(direccionFile, { headers, params: { valores } })
            .then((result) => {

                this.setState({
                    directorio: result.data
                })
                this.setState({
                    isLoading: false,
                })

                console.log(JSON.stringify(result.data));
                console.log('Resultado ---> ', result)
            }).catch((error) => {
                this.setState({
                    isLoading: false,
                  });
              });
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////////

    render() {
        const isLoading = this.state.isLoading;

        return (
            <>
                <Header title={'Información Empresas'} />
                <Container className=" mt--7" fluid>

                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardBody>
                                    <Row>
                                        <Col>
                                            <button
                                                className="btn btn-sm btn-primary"
                                                onClick={this.props.history.goBack}
                                            >
                                                Atrás
                                            </button>
                                        </Col>



                                    </Row>
                                </CardBody>
                            </Card>

                            <Card className="mt-3 shadow">
                                <CardBody>
                                    <CardTitle>CARGA DE DOCUMENTOS DEL AYUNTAMIENTO </CardTitle>
                                    <Row>

                                        <Col md="12" lg="5" className="pt-3" >
                                            <FormGroup>
                                                <Form onSubmit={this.onSubmit}>
                                                    <input type="file" name="files" className="custom-file-input" onChange={this.onFileChange} ref={this.inputEl} multiple />

                                                    <button disabled={this.state.saveButtonDisabled} id="gpsProptooltip" type="submit" color="#2dce89" className="btn btn-primary btn-sm btn-circle" >
                                                        <span className="btn-inner--icon">
                                                            <i className={"bi bi-cloud-arrow-up"} style={{ fontSize: 25 }}></i>
                                                        </span>
                                                        <span className="btn-inner--text">Subir Ficheros</span>
                                                        <UncontrolledTooltip delay={0} placement="top" target="gpsProptooltip">
                                                            SUBIR FICHEROS AL SERVIDOR
                                                        </UncontrolledTooltip>
                                                    </button>
                                                </Form>
                                            </FormGroup>
                                        </Col>

                                     </Row>

                                    <FormText color="muted">
                                        Seleccionar los fichero para subir al servidor
                                    </FormText>
                                    <LoadingOverlay
                                        active={isLoading}
                                        spinner
                                        text="Cargando...">
                                        <Row className="card-deck">
                                            <Card className="mt-3 mb-3 p-3 card-document">
                                            </Card>
                                        </Row>


                                    </LoadingOverlay>
                                </CardBody>
                            </Card>
                            {this.state.alert}
                        </div>
                    </Row>

                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardBody>

                                    <Row id="contratos_resumen" className="card-deck mt-2">
                                        <Card className="shadow">
                                            <DataTable
                                                title="LISTADO DE DOCUMENTOS"
                                                columns={columnsFiles(this.handleButtonClick)}
                                                data={this.state.directorio}
                                                sortIcon={sortIcon} // use a material icon for our sort icon. rdt will rotate the icon 180 degrees for you           fixedHeader = {true}
                                                noDataComponent={"Sin datos para mostrar"}
                                                pagination
                                                paginationPerPage={10}
                                                paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 40]}

                                                highlightOnHover
                                                striped
                                                pointerOnHover
                                                selectableRowsHighlight

                                                customStyles={customStyles}

                                            />
                                        </Card>
                                    </Row>

                                </CardBody>
                            </Card>
                            {this.state.alert}

                        </div>
                    </Row>
                </Container>

            </>
        );
    }
};




export default withRouter(gestionFicheros);
